import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { ScratchpadContext } from "contexts/ScratchpadProvider";
import { Button } from "components/bootstrap";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import NavIcon from "components/navigation/NavIcon";
import NavItemStateIndicator, { hoverIndicatorStyles } from "../common/NavItemStateIndicator";
const Toggle = styled(Button)(
  ({ theme }) => css`
    padding: 0 15px;
    background: none;
    border: 0;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
      background: transparent;
      color: ${theme.colors.variant.darker.default};
    }
  `
);
const ScratchpadToggle = () => {
  const { toggleScratchpadVisibility } = useContext(ScratchpadContext);
  return /* @__PURE__ */ React.createElement("li", { role: "presentation" }, /* @__PURE__ */ React.createElement(
    Toggle,
    {
      bsStyle: "link",
      type: "button",
      "aria-label": "Scratchpad",
      id: "scratchpad-toggle",
      onClick: toggleScratchpadVisibility
    },
    /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, /* @__PURE__ */ React.createElement(NavIcon, { type: "scratchpad", title: "Scratchpad" }))
  ));
};
export default ScratchpadToggle;
